module.exports = __webpack_public_path__ + "static/img/rabbit.df693c68.png";